import React, { useState } from "react";

const Dropdown = ({ label, options = [], onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const [loadingKey, setLoadingKey] = useState(null);

  const handleSelect = async (option) => {
    
    setLoadingKey(option.key); // Attiva lo spinner per questa opzione
    setSelectedOption(option);
    
    if (option.action) {
      setTimeout(async ()=> {
        try {
          await option.action(); // supporta funzioni async
          setLoadingKey(null); // Disattiva lo spinner
          setIsOpen(false);
          if (onSelect) onSelect(option);
        } catch (e) {
          console.error("Errore nell'azione:", e);
          setLoadingKey(null); // Disattiva lo spinner
          setIsOpen(false);
          if (onSelect) onSelect(option);
        }
      }, 1000);
      
    }
  };




  return (
    <div className="rtds-dropdown-menu rtds-relative">
      <button
      aria-label="Apri menu"
        onClick={() => setIsOpen(!isOpen)}
        className="rtds-dropdown-menu__trigger rtds-dropdown-trigger rtds-group rtds-w-full rtds-flex rtds-items-center hover:rtds-underline hover:rtds-content-primary aria-expanded:rtds-background-02 lg:aria-expanded:bg-white aria-expanded:rtds-content-01 aria-expanded:rtds-bg-white lg:aria-expanded:rtds-content-02 lg:aria-expanded:rtds-relative rtds-p-3 rtds-gap-2 rtds-text-sm lg:rtds-text-base"
      >
        <svg
          className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:rtds-translate-x-1"
          aria-hidden="true"
          focusable="false"
          role="img"
        >
          <use
            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--ellipsis-vertical`}
          />
        </svg>
      </button>

      {isOpen && (
        <ul
        className="rtds-px-2 rtds-absolute rtds-border rtds-rounded rtds-border-gray-02 rtds-background-01 rtds-gap-2"
        style={{ right: "0" }}
      >
        {options.length > 0 ? (
          options.map((option) => (
            <li key={option.key} className="rtds-mb-2">
              <button
                disabled={loadingKey}
                onClick={() => handleSelect(option)}
                className={option.className}
              >
                {loadingKey === option.key ? (
                  <>
                    <svg
                      className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 rtds-animate-spin"
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                    >
                      <use
                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                      />
                    </svg>
                    <span className="rtds-sr-only">
                      Operazione in corso...
                    </span>
                  </>
                ) : (
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-transition-all rtds-duration-200 rtds-ease-out rtds-transform group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${option.icon}`}
                    />
                  </svg>
                )}
                {option.label}
              </button>
            </li>
          ))
        ) : (
          <li className="px-4 py-2 text-gray-400" key="no_options">
            Nessuna opzione disponibile
          </li>
        )}
      </ul>
      )}
    </div>
  );
};

export default Dropdown;
